import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { formatDate } from "../../../../commons/FormatValue";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import PMNosService from "../../../../services/pmno.service";

export default function WorkingPlan() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row?.rowIndex,
      sortable: true,
      minWidth: "110px"
    },
    {
      name: "หมายเลขแผน PM",
      selector: (row) => row?.Pm_No,
      sortable: true,
      minWidth: "250px"
    },
    {
      name: "PM/ครั้งที่",
      selector: (row) => row?.Pm_Item,
      minWidth: "120px"
    },
    {
      name: "เดือน/ครั้ง",
      selector: (row) => row?.Month_Item,
      minWidth: "120px"
    },
    {
      name: "เลขที่โครงการ",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Project_No,
      minWidth: "180px"
    },
    {
      name: "เลขที่สัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_No,
      minWidth: "180px"
    },
    {
      name: "ประเภทที่สัญญา",
      selector: (row) => row?.PMPlan?.CustContractItem?.Contract_Type,
      minWidth: "180px"
    },
    {
      name: "วันที่เริ่มสัญญา",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Contract_Start_Date,
      format: (row) =>
        formatDate(
          row?.PMPlan?.CustContractItem?.CustContract?.Contract_Start_Date
        ),
      minWidth: "180px"
    },
    {
      name: "วันที่สิ้นสุดสัญญา",
      selector: (row) =>
        row?.PMPlan?.CustContractItem?.CustContract?.Contract_End_Date,
      format: (row) =>
        formatDate(
          row?.PMPlan?.CustContractItem?.CustContract?.Contract_End_Date
        ),
      minWidth: "180px"
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_Code,
      minWidth: "200px"
    },
    {
      name: "เลขที่สาขา",
      selector: (row) => row?.PMPlan?.Customer?.Cus_NumBranch,
      minWidth: "150px"
    },
    {
      name: "ชื่อลูกค้า/สาขา ",
      selector: (row) => row?.PMPlan?.Customer?.Cus_Name,
      minWidth: "300px"
    },
    {
      name: "รหัสสินค้า",
      selector: (row) => row?.PMPlan?.Item?.Item_Code,
      minWidth: "200px"
    },
    {
      name: "รายละเอียดสินค้า",
      selector: (row) => row?.PMPlan?.Item?.Item_Name_TH,
      minWidth: "300px"
    },
    {
      name: "วันที่เริ่มงาน",
      selector: (row) => row?.Job_Start_Date,
      format: (row) => formatDate(row?.Job_Start_Date),
      minWidth: "180px"
    },
    {
      name: "วันที่เสร็จงาน",
      selector: (row) => row?.Job_Finish_Date,
      format: (row) => formatDate(row?.Job_Finish_Date),
      minWidth: "180px"
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton
          state={{ edit: { name: "working_plan" } }}
          isDisabled={{ edit: row?.Pm_No_Status !== "OPEN" }}
        />
      ),
      right: true,
      width: "120px"
    }
  ];
  const searchInput = [
    {
      name: "PMPlan.Plan_No",
      label: "หมายเลขแผน PM",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Pm_Item",
      label: "PM/ครั้งที่",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "1_5",
      minKeywordLength: 1
    },
    {
      name: "PMPlan.CustContractItem.CustContract.Customer.Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.CustContractItem.CustContract.Customer.Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "4_5"
    },
    {
      name: "PMPlan.Customer.Cus_Code",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "PMPlan.Customer.Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "1_5"
    },
    {
      name: "PMPlan.Customer.Cus_Name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      size: "7_5"
    },
    {
      name: "Admin_Brand",
      label: "ธุรการผู้รับผิดชอบแบรนด์",
      classNames: { col: "mb-3", label: "mb-1" }
    },
    {
      name: "Team_Chief_Mc",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 9
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: PMNosService.getAllPMNos(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 bg-transparent border-bottom-0">
          <Card.Title className="mb-0 fs-2 text-center">
            ข้อมูลแผนเข้าทำงาน PM
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <SearchFilter
            data={data}
            inputField={searchInput}
            fieldClassName={{ actionButton: "w-100 text-end" }}
            searchCallback={(search) => setSearchValue(search)}
          />
        </Card.Body>
      </Card>

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
          <Card.Title className="mb-0 fs-2">รายละเอียดรอบแผน PM</Card.Title>

          <ButtonLink
            linkTo="create"
            stateData={{ name: "working_plan" }}
            buttonName="สร้างแผนเข้าทำงาน PM แต่ละสาขา"
            buttonClass="px-4 py-2 rounded-pill"
          />
        </Card.Header>

        <Card.Body>
          <Table
            data={data}
            column={columns}
            searchFilter={searchValue}
            pending={loading}
            pagination
          />
        </Card.Body>
      </Card>
    </>
  );
}
